module.exports = __webpack_public_path__ + "img/00039.349a3ca0.webp";